import { getUserDevice } from 'utils/device';
import { AndroidInstructions } from './AndroidInstructions';
import { DesktopInstructions } from './DesktopInstructions';
import { IOSInstructions } from './IOSInstructions';

export const SettingsGuide = () => {
  const { isiOS, isAndroid, isDesktop } = getUserDevice(navigator?.userAgent);

  if (isDesktop) return <DesktopInstructions />;
  if (isiOS) return <IOSInstructions />;
  if (isAndroid) return <AndroidInstructions />;

  return null;
};
